import {getAppleAuthRedirectLink} from './getAppleAuthRedirectLink';
import {sendGoogleCredentials} from './sendGoogleCredentials';

export const SSOService = {
  getAppleAuthRedirectLink,
  sendGoogleCredentials
};

